// NOTE - Exposes the current devicePixelRatio as a `--dpr` CSS variable on
// <html>, kept in sync when the DPR changes (window moved to another screen,
// browser zoom, …). Used to render true 1-physical-pixel hairlines: an element
// sized 1 CSS px scaled by `1 / var(--dpr)` renders exactly one device pixel,
// crisply and consistently regardless of subpixel positioning.
export function installDevicePixelRatioVariable() {
  const update = () => {
    const dpr = window.devicePixelRatio || 1
    document.documentElement.style.setProperty('--dpr', String(dpr))

    // NOTE - A resolution media query fires once when the current DPR stops
    // matching, so we re-register on every change to keep tracking.
    window
      .matchMedia(`(resolution: ${dpr}dppx)`)
      .addEventListener('change', update, { once: true })
  }

  update()
}
